import styled from "styled-components";

import { OutlineButton } from "components/Button";

export const MyAccountPageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const MyAccountContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-width: 327px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 516px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 448px;
  }
`;

export const Title = styled.h1`
  text-align: left;
  align-self: flex-start;
  font-weight: 700;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(28)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(24)};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
  }
`;

export const Details = styled.div`
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(48)};
  width: 100%;
  align-self: flex-start;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 20px;
`;

export const DetailsTitle = styled.h1`
  text-align: left;
  align-self: flex-start;
  font-weight: 700;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
  }
`;

export const GreyContainer = styled.div`
  background: ${({ theme }) => theme.customTheme.palette.grey.lightF3};
  width: 100%;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ItemTitle = styled.span`
  font-weight: 700;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
`;

export const ItemContent = styled.span`
  font-weight: 400;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.grey.light5E};
`;

export const ButtonContainer = styled.div`
  align-self: center;
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(28)};
  margin-bottom: ${({ theme }) => theme.customTheme.pxToRem(28)};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 327px;
`;

export const LogoutButton = styled(OutlineButton)`
  width: 100%;
  padding: 14px 24px;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
  border-color: ${({ theme }) => theme.customTheme.palette.black.black1};
  text-decoration: none;
`;
